jQuery(document).ready(function ($) {



  $('.wf-testimonial-slider-slides').slick({
    arrows: true,
    prevArrow: "<button type='button' class='slick-prev' aria-label='Previous'><div data-name='Previous Arrow' class='wf-slider-prev-icon' aria-hidden='true'><svg xmlns='http://www.w3.org/2000/svg' width='54' height='54' viewBox='0 0 54 54'><g id='Left_Arrow' data-name='Left Arrow' transform='translate(1225.5 4998.5) rotate(180)'><g id='Ellipse_7' data-name='Ellipse 7' transform='translate(1225.5 4998.5) rotate(180)' fill='none' stroke='#5c0f8b' stroke-miterlimit='10' stroke-width='3'><circle cx='27' cy='27' r='27' stroke='none'/><circle cx='27' cy='27' r='25.5' fill='none'/></g><path id='Path_297' data-name='Path 297' d='M33.118,41.467,20.151,28.5,33.118,15.533' transform='translate(1226 5000) rotate(180)' fill='none' stroke='#5c0f8b' stroke-miterlimit='10' stroke-width='3'/></g></svg></div></button>",
    nextArrow: "<button type='button' class='slick-next' aria-label='Next'><div data-name='Next Arrow' class='wf-slider-next-icon' aria-hidden='true'><svg xmlns='http://www.w3.org/2000/svg' width='54' height='54' viewBox='0 0 54 54'><g id='Right_Arrow' data-name='Right Arrow' transform='translate(-1171.5 -4944.5)'><g id='Ellipse_7' data-name='Ellipse 7' transform='translate(1225.5 4998.5) rotate(180)' fill='none' stroke='#5c0f8b' stroke-miterlimit='10' stroke-width='3'><circle cx='27' cy='27' r='27' stroke='none'/><circle cx='27' cy='27' r='25.5' fill='none'/></g><path id='Path_297' data-name='Path 297' d='M33.118,41.467,20.151,28.5,33.118,15.533' transform='translate(1226 5000) rotate(180)' fill='none' stroke='#5c0f8b' stroke-miterlimit='10' stroke-width='3'/></g></svg></div></button>",
    dots: true,
    autoplay: false,
    //centerMode: true,
    //centerPadding: '25%',
    responsive: [{
      breakpoint: 600,
      settings: {
        arrows: false,
        dots: true,
        centerMode: true,
        centerPadding: '10%',
      },
    }, ],
  });


    //All Recipes Slider Block
    $('.wf-all-recipes-slider-inner').slick({
      //centerMode: true,
      slidesToShow: 1,
      arrows: true,
      prevArrow: "<button type='button' class='slick-prev' aria-label='Previous'><div data-name='Previous Arrow' class='wf-slider-prev-icon' aria-hidden='true'><svg xmlns='http://www.w3.org/2000/svg' width='14' height='17.662' viewBox='0 0 14 17.662'><path id='Path_14356' data-name='Path 14356' d='M633.652,243.07l-8.845,14-8.817-14,8.817,3.211Z' transform='translate(257.07 -615.99) rotate(90)' fill='#222259'/></svg></div></button>",
      nextArrow: "<button type='button' class='slick-next' aria-label='Next'><div data-name='Next Arrow' class='wf-slider-next-icon' aria-hidden='true'><svg xmlns='http://www.w3.org/2000/svg' width='14' height='17.662' viewBox='0 0 14 17.662'><path id='Path_14355' data-name='Path 14355' d='M633.652,243.07l-8.845,14-8.817-14,8.817,3.211Z' transform='translate(-243.07 633.652) rotate(-90)' fill='#222259'/></svg></div></button>",
      dots: true,
      swipe: true,
      //infinite: false,
      swipeToSlide: true,
      //adaptiveHeight: true,
      responsive: [{
        breakpoint: 900,
        settings: {
          arrows: false,
          appendDots: '.wf-all-recipes-slider-inner',
        },
      }, ],
    });

    // History Slider
    $('.wf-history-slides').on('init', function(event, slick){
      var dots = $( '.slick-dots li' );
      dots.each( function( k, v){
        $(this).find( 'button' ).addClass( 'heading'+ k );
      });
      var items = slick.$slides;
      items.each( function( k, v){
          var text = $(this).find( 'h2' ).text();
          $( '.heading' + k ).text(text);
      });
    });
    $('.wf-history-slides').slick({
      dots: true,
      appendDots: '.wf-history-slides',
      focusOnSelect: true,
      infinite: true,
      arrows: true,
      prevArrow: "<button type='button' class='slick-prev' aria-label='Previous'><div data-name='Previous Arrow' class='wf-slider-prev-icon' aria-hidden='true'><svg xmlns='http://www.w3.org/2000/svg' width='14' height='17.662' viewBox='0 0 14 17.662'><path id='Path_14356' data-name='Path 14356' d='M633.652,243.07l-8.845,14-8.817-14,8.817,3.211Z' transform='translate(257.07 -615.99) rotate(90)' fill='#222259'/></svg></div></button>",
      nextArrow: "<button type='button' class='slick-next' aria-label='Next'><div data-name='Next Arrow' class='wf-slider-next-icon' aria-hidden='true'><svg xmlns='http://www.w3.org/2000/svg' width='14' height='17.662' viewBox='0 0 14 17.662'><path id='Path_14355' data-name='Path 14355' d='M633.652,243.07l-8.845,14-8.817-14,8.817,3.211Z' transform='translate(-243.07 633.652) rotate(-90)' fill='#222259'/></svg></div></button>",
      //speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      //centerMode: true,
      //centerPadding: '30px',
    });


  $('.wf-product-slider').slick({
    autoplay: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
    draggable: false,
    arrows: false,
    dots: false,
    touchMove: false,
    swipe: false,
    //asNavFor: '.slider-nav-thumbnails',
  });

  $('.slider-nav-thumbnails').slick({
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    draggable: false,
    focusOnSelect: false,
    asNavFor: '.wf-product-slider',
    dots: false,
    centerMode: false,
    //focusOnSelect: false,
    touchMove: false,
    swipe: false,

  });

  /*  $('.slider-nav-thumbnails .slick-slide').on('click', function (event) {
     $('.wf-product-slider').slick('slickGoTo', $(this).data('slickIndex'));
     $('.slider-nav-thumbnails .slick-slide').removeClass( 'slick-current' );
     $(this).toggleClass('slick-thumb-current');
  }); */

  // Remove active class from all thumbnail slides
  $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');

  // Set active class to first thumbnail slides
  $('.slider-nav-thumbnails .slick-slide').eq(0).addClass('slick-active');

  // On before slide change match active thumbnail to current slide
  /* $('.wf-product-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var mySlideNumber = nextSlide;
    $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');
    $('.slider-nav-thumbnails .slick-slide').eq(mySlideNumber).addClass('slick-active');
  }); */

  $('.slider-nav-thumbnails .slick-slide').on('click', function (event) {
    $('.wf-product-slider').slick('slickGoTo', $(this).data('slickIndex'));
    $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');
    $(this).addClass('slick-active');
  });


  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true
  });



});